export default "__VITE_ASSET__CoEPgoF9__"